import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  Collapse,
  Alert,
  Table,
  Input,
  Label
} from "reactstrap";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';

import FormCadastroProduto from './FormCadastroProdutos';
import useToggle from 'lib/useToggle';
import settings from 'settings';
import rotas from 'services/rotas';
import CentralPrecos from '../../../components/CentralPrecos'
import Loading from 'lib/loading';
import rest from 'lib/rest';
import { FormGroup } from 'reactstrap';
import ReactSelect from 'components/Form/Select/Select';

const CadastroProdutos = () => {

  const colunas = [
    {
      dataField: 'produto_id',
      text: 'Código',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'produto',
      text: 'Produto',
      align: 'left',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'apresentacao',
      text: 'Apresentação',
      align: 'left',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'fornecedor',
      text: 'Fornecedor',
      align: 'left',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'prod_prcompra',
      text: 'Preço de Compra',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'prod_prvenda',
      text: 'Preço de Venda',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'prod_prpromocao',
      text: 'Preço de Promoção',
      headerStyle: { cursor: 'default' }
    }
  ];

  const { SearchBar } = Search;
  const [data, setdata] = useState();
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useToggle(false);
  const [produto_id, setProduto_id] = useState(0);
  const [filial_id, setFilial_id] = useState(1);
  const [paginacao, setPaginacao] = useState(-1);
  const [pagina, setPagina] = useState(1);
  const [estoqueOL, setEstoqueOL] = useState([]);
  const [loadingOL, setLoadingOL] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [listaFornecedor, setListaFornecedor] = useState([]);
  const [listaCategoria, setListaCategoria] = useState([]);
  const [fornecedor_id, setFornecedor_id] = useState(0);
  const [categoria_id, setCategoria_id] = useState(0);
  const [prod_ativo, setProd_ativo] = useState('S');
  const [produto_saldo, setProduto_saldo] = useState('N');

  useEffect(() => {
    const load = loading;
    //if (load === true) {
    listaProdutos();
    listarFornecedores();
    listarCategorias();
    //}
  }, [filial_id])

  const listaProdutos = () => {
    const parametros = {
      todos: 'S',
      filial_id: filial_id
    }
    const url = settings.url + rotas.produtos;
    const retorno = rest.post(url, parametros);

    retorno.then(ret => {
      //console.log(ret.data);
      setdata(ret.produtos);
      setPaginacao(parseInt(ret.total));
      setLoading(false);
    })
  }

  const pesquisaProduto = (type, filtros) => {

    if (filtros == '') {
      type = 'pagination';
      filtros = {
        page: 1
      }
    }

    if (type === 'search') {
      // const pesquisa = pesquisa;
      const parametros = {
        todos: 'N',
        produto:        pesquisa,
        filial_id:      filial_id,
        fornecedor_id:  fornecedor_id,
        categoria_id:   categoria_id,
        prod_ativo:     prod_ativo,
        produto_saldo:  produto_saldo
      }

      const url = settings.url + rotas.produtos;
      const retorno = rest.post(url, parametros);
      setPagina(1);

      retorno.then(ret => {
        setdata(ret.produtos);
        setPaginacao(parseInt(ret.total));
      })

    }

    if (type === 'pagination') {
      // let pesquisa = '';
      // if (filtros.searchText.length > 0) {
      //   pesquisa = filtros.searchText;
      // }
      const parametros = {
        todos: 'S',
        paginacao: { pagina: filtros.page },
        produto: pesquisa,
        filial_id: filial_id,
        fornecedor_id: fornecedor_id,
        categoria_id:   categoria_id,
        prod_ativo:     prod_ativo,
        produto_saldo:  produto_saldo
      }

      const url = settings.url + rotas.produtos;
      const retorno = rest.post(url, parametros);

      retorno.then(ret => {
        //console.log(ret.data);
        if (ret.produtos != null) {
          setdata(ret.produtos);
        }
        setPagina(filtros.page)
        setPaginacao(parseInt(ret.total));
      })
    }
  }

  const showForm = (produto_id) => {
    //console.log(produto_id);
    setProduto_id(produto_id)
    setModal();
  }

  const onChangePesquisa = (e) => {
    setPesquisa(e.target.value)
  }

  const estoqueOutrasLojas = (produto_id) => {
    setLoadingOL(true)

    const url = settings.url + rotas.listarEstoqueOL;
    const retorno = rest.get(url + '?produto_id=' + produto_id);

    retorno.then(ret => {
      if (ret.success === 'S') {
        setEstoqueOL(ret.retorno);
        setLoadingOL(false);
      }
    })
  }

  const listarFornecedores = () => {
    const url = settings.url + rotas.fornecedorProduto;

    //const retorno = rest.get(url + '/' + loja_id);
    const retorno = rest.get(url + '?cadProd=S');
    let oFornecedores = [];
    retorno.then(ret => {
      if (ret.success === 'S') {
        ret.lista.map(fornecedor => {
          oFornecedores.push({ id: fornecedor.fornecedor_id, title: fornecedor.fornecedor })
        });
        setListaFornecedor(oFornecedores);
      }
    })
  }

  const listarCategorias = () => {
    const url = settings.url + rotas.categoriaProduto;

    const retorno = rest.get(url + '?cadProd=S');
    let oCategoria = [];
    retorno.then(ret => {
      if (ret.success === 'S') {
        ret.lista.map(categoria => {
          oCategoria.push({ id: categoria.categoria_id, title: categoria.categoria })
        });
        setListaCategoria(oCategoria);
      }
    })
  }

  const changeSelect = (e,comp) => {
    if(comp.name == "fabricante"){
      setFornecedor_id(e.id);
    }

    if(comp.name = "categoria"){
      setCategoria_id(e.id);
    }
  }

  const onChangeCB = (e) =>{
    if(e.target.name == "produto_saldo"){
      if(e.target.checked == true){
        setProduto_saldo('S')
      }else{
        setProduto_saldo('N')
      }

    }
    
    if(e.target.name == "prod_ativo"){
      if(e.target.checked == true){
        setProd_ativo('S')
      }else{
        setProd_ativo('N')
      }
    }
  }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  } else {
    return (
      <>
        <div className="content">
          <Container fluid>
            <Row>
              <Col md="9" className="p-0">
                <Card className="h-100">

                  <CardHeader>
                    <Row>
                      <Col>
                        <CardTitle>CADASTRO DE PRODUTOS</CardTitle>
                      </Col>

                      <CentralPrecos
                        //dados={[{ id: 1, central: 'Nome central 1', ativo: 'S' }, { id: 2, central: 'Nome central 2', ativo: 'N' }]}
                        refresh={setFilial_id}
                      >
                      </CentralPrecos>
                    </Row>
                  </CardHeader>

                  <CardBody>
                    <Modal
                      size='xl'
                      isOpen={modal}
                    >
                      <ModalHeader>Cadastro de Produtos</ModalHeader>
                      <FormCadastroProduto
                        produto_id={produto_id}
                        filial_id={filial_id}
                        //setValor={this.setvalor.bind(this)}
                        //insereProduto={() => { this.insereProduto() }}
                        closeModal={setModal}
                      >
                      </FormCadastroProduto>
                    </Modal>
                    {/* 
                  <SweetAlert
                    show={this.state.sweet.show}
                    title={this.state.sweet.title}
                    text={this.state.sweet.text}
                    onConfirm={() => this.setState({ sweet: { show: false, title: "", text: "" } })}
                  /> */}

                    <ToolkitProvider
                      keyField="produto_id"
                      data={data}
                      columns={colunas}
                      search
                    >
                      {
                        props => (
                          <div>
                            <Container>
                              <Row>
                                <Col md="3" className="pl-0">
                                  <Button
                                    className="m-0 w-100"
                                    color="primary"
                                    outline
                                    style={{ padding: '5px 20px' }}
                                    onClick={() => { showForm(0) }}
                                  >
                                    <i className="fas fa-plus" />
                                    Cadastrar
                                  </Button>
                                </Col>

                                <Col md="7">
                                  <Input
                                    type="search"
                                    placeholder="Buscar Produtos..."
                                    onChange={onChangePesquisa}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { pesquisaProduto('search', '') } }}
                                  >
                                  </Input>
                                  {/* <SearchBar
                                    placeholder="Buscar Produtos..."
                                    style={{ padding: '5px' }}
                                    {...props.searchProps}
                                  />                                   */}
                                </Col>
                                <Col md="2"  className="pr-0">
                                  <Button
                                    className="m-0 w-100"
                                    color="success"
                                    style={{ padding: '3px 15px' }}
                                    onClick={() => { pesquisaProduto('search', '') }}
                                  >
                                    <i className="nc-icon nc-zoom-split" style={{ fontSize: '20px' }} />
                                  </Button>
                                </Col>
                              </Row>

                              <Row>
                                <Col md='12' className="px-0">
                                  <Row className="card-2 pb-3 pt-4">
                                    <Col className="d-flex flex-column">
                                      <span className="tag-card">Filtros</span>
                                      <Row>
                                        <Col md='12' className='d-flex justify-content-between'>
                                          <FormGroup check inline className="mt-2">
                                            <Label check>
                                              <Input
                                                type="checkbox"
                                                id="prod_ativo"
                                                name="prod_ativo"
                                                onClick={onChangeCB}
                                                // checked = {prod_ativo == 'S' ? true : false}
                                              defaultChecked={prod_ativo === 'S' ? true : false}
                                              />
                                              <span className="form-check-sign" />Somente Produto Ativo
                                            </Label>
                                          </FormGroup>{" "}

                                          <FormGroup check inline className="mt-2">
                                            <Label check>
                                              <Input
                                                type="checkbox"
                                                id="produto_saldo"
                                                name="produto_saldo"
                                                onClick={onChangeCB}
                                                // checked = {produto_saldo == 'S' ? true : false}
                                              defaultChecked={produto_saldo === 'S' ? true : false}
                                              />
                                              <span className="form-check-sign" />Somente Produto com saldo
                                            </Label>
                                          </FormGroup>{" "}
                                        </Col>
                                      </Row>


                                      <Row>
                                        <Col md='6'>
                                          <FormGroup>
                                            <ReactSelect
                                              name="fabricante"
                                              label="Fabricante"
                                              placeholder="Selecione"
                                              options={listaFornecedor}
                                              // defaultValue={{ id: form.fornecedor_id, title: form.fornecedor.title ? form.fornecedor.title : form.fornecedor }}
                                              onChange={changeSelect}
                                            // erro={form.fornecedor_id > 0 ? false : true}
                                            >
                                            </ReactSelect>
                                          </FormGroup>
                                        </Col>

                                        <Col md='6'>
                                          <FormGroup>
                                            <ReactSelect
                                              name="categoria"
                                              label="Categoria"
                                              placeholder="Selecione"
                                              options={listaCategoria}
                                              // defaultValue={{ id: form.fornecedor_id, title: form.fornecedor.title ? form.fornecedor.title : form.fornecedor }}
                                              onChange={changeSelect}
                                            // erro={form.fornecedor_id > 0 ? false : true}
                                            >
                                            </ReactSelect>
                                          </FormGroup>
                                        </Col>

                                      </Row>


                                    </Col>
                                  </Row>
                                </Col>

                                {/* <Row className='pt-3'> */}

                                {/* </Row> */}

                              </Row>
                            </Container>

                            <hr />

                            <BootstrapTable
                              striped
                              keyField="produto_id"
                              noDataIndication="Nenhum registro encontrado"
                              rowStyle={{ cursor: "pointer" }}
                              hover
                              pagination={paginationFactory({
                                page: pagina,
                                sizePerPage: 10,
                                totalSize: paginacao,
                                hideSizePerPage: true,
                                hidePageListOnlyOnePage: true,
                                showTotal: false,
                              })}
                              remote={{ search: true, pagination: true }}
                              onTableChange={pesquisaProduto}
                              {...props.baseProps}
                              data={data}
                              columns={colunas}
                              rowEvents={
                                {
                                  onDoubleClick: (e, row, rowIndex) => {
                                    showForm(row.produto_id);
                                  },

                                  onClick: (e, row, rowIndex) => {
                                    estoqueOutrasLojas(row.produto_id)
                                  }
                                }
                              }
                              selectRow={{
                                mode: 'radio',
                                clickToSelect: true
                              }
                              }
                            />
                          </div>
                        )
                      }
                    </ToolkitProvider>
                  </CardBody>
                </Card>
              </Col>

              <Col md={3}>
                <Card className="h-100">
                  <CardBody className="px-3 pb-0">
                    <h6 className='text-center'>Estoque Lojas</h6>
                    {estoqueOL.length === 0 && loading === false
                      ?
                      <div className='d-flex align-items-center h-100 text-center text-secondary justify-content-center'>
                        <h2 style={{ color: "#e6e6e6" }}>Selecione <br /> um <br /> produto</h2>
                      </div>
                      :
                      <></>
                    }

                    {loadingOL ?
                      <Loading tipo="paginas"></Loading>
                      :
                      <Table
                        bordered
                      >
                        {estoqueOL.length > 0 ?
                          <thead className="text-default">
                            <tr>
                              <th>Loja</th>
                              <th className="text-center" style={{ width: "15%" }}>Saldo</th>
                            </tr>
                          </thead>
                          :
                          <></>
                        }
                        <tbody>
                          {estoqueOL.map((estoque, index) =>
                            <tr key={index} >
                              <td style={{ backgroundColor: estoque.prod_saldo > 0 ? '#b3ffcc' : '' }}>{estoque.fantasia}</td>
                              <td style={{ backgroundColor: estoque.prod_saldo > 0 ? '#b3ffcc' : '' }}>{estoque.prod_saldo}</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    }
                  </CardBody>
                </Card>
              </Col>

            </Row>
          </Container>
        </div>
      </>
    )
  }
}


export default CadastroProdutos;